import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon } from 'lucide-react';
import { ActionButton } from './ActionButton';
const mockupUrl = 'https://cdn.magicpatterns.com/uploads/2jfCAXtQmaUeKibGzrZwTr/Mockup_-_SN12_(1x1).webp';
export function Hero() {
  return <section className="relative overflow-hidden bg-brand-dark px-4 pb-16 pt-12 sm:pb-24 sm:pt-16" data-id="element-66" data-mp="4lqfmm6wsuyr">
      <div className="pointer-events-none absolute inset-x-0 top-0 h-px bg-brand-green/40" data-id="element-67" data-mp="1297c23jh2z9b" />
      <div className="relative mx-auto max-w-5xl text-center" data-id="element-68" data-mp="xae7x1q2sklt">
        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="-mb-2 -mt-8 font-display text-lg font-bold tracking-[.18em] text-brand-light sm:text-2xl" data-id="element-69" data-mp="xb5tdjpyl1yd">
          🌿 BIOMA LÍVIDO™
        </motion.p>
        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.1
      }} className="mx-auto mt-5 max-w-5xl font-display text-[19px] font-bold text-white sm:text-5xl lg:text-6xl" data-id="element-70" data-mp="3d2l9jc5qb50p">
          Reducí las crisis de tu hijo en 30 días{' '}
          <span className="text-brand-light" data-id="element-71" data-mp="3o6u71a6kmrcx">
            con un sistema de hábitos posible para acompañar su tratamiento.
          </span>
        </motion.h1>
        <motion.div initial={{
        opacity: 0,
        y: 26
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.2
      }} className="mx-auto -my-3 max-w-xs sm:-my-7 sm:max-w-lg" data-id="element-72" data-mp="3e8msexzr8le3">
          <img src={mockupUrl} alt="Mockup del Protocolo Cerebro en Equilibrio" width="1024" height="1024" fetchPriority="high" loading="eager" decoding="async" className="w-full drop-shadow-2xl" data-id="element-73" data-mp="35aaueawk6lbm" />
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.35
      }} className="mx-auto max-w-2xl" data-id="element-74" data-mp="2vgu0z80c388h">
          <p className="-mb-2 font-display text-base font-bold tracking-[.14em] text-brand-gold sm:text-xl" data-id="element-75" data-mp="2lmuz8a469qh2">
            PROTOCOLO CEREBRO EN EQUILIBRIO™
          </p>
          <p className="-mb-4 mt-3 text-slate-200 sm:text-base text-[13px]" data-id="element-76" data-mp="najhpovn0ffj">
            Tu mapa de neuronutrición integrativa. Diseñado para madres argentinas que acompañan el tratamiento médico de sus hijos con epilepsia.
          </p>
          <div className="-mb-5 mt-5 flex flex-wrap justify-center gap-2 text-xs font-medium text-slate-300 sm:text-sm" data-id="element-77" data-mp="dbaoiy8lj4u8">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-78" data-mp="1622kbulr1rh1">
              <FileTextIcon className="h-4 w-4 text-brand-light" data-id="element-79" data-mp="111y9ak3m1oy7" />
              100% PDF
            </span>
            <span className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-brand-ink px-3 py-2" data-id="element-80" data-mp="x032x16toldk">
              <ZapIcon className="h-4 w-4 text-brand-gold" data-id="element-81" data-mp="3lu9wv02xxwap" />
              Acceso en 5 min
            </span>
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.45
      }} className="mx-auto mt-7 max-w-lg" data-id="element-82" data-mp="1x9kw0qpijcjb">
          <ActionButton href="#pricing" showTrust data-id="element-83" data-mp="269r3nvyj5iak">
            🧠 QUIERO MI PROTOCOLO AHORA
          </ActionButton>
        </motion.div>
      </div>
    </section>;
}